package team.platforma.multiplatform_material_extension.ui.core.global_style.area

import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

/**
 * [TextFieldCommon].apply {
 *
 * &nbsp;&nbsp;&nbsp;&nbsp;[mSupportArea] =
 *
 *
 * }
 */
object TextFieldCommon {
    internal var mSupportArea: Dp = 24.dp
    fun define(supportAreaHeight : Dp = 24.dp) {
        mSupportArea = supportAreaHeight
    }
}
fun supportArea(): Dp {
    return TextFieldCommon.mSupportArea
}